import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  @Input() acceptTypes!: string;
  @Input() fileTypes!: string;
  @Input() multiSelect = false;

  @Output() fileSelected = new EventEmitter<File[]>();

  files: File[] = [];

  constructor() {
  }

  ngOnInit(): void {
  }

  dropFile(files: File[]) {
    this.handleFileInternal(files);
  }

  selectFile(event: Event) {
    if (event.target && 'files' in event.target) {
      this.handleFileInternal(event.target['files'] as File[] || []);
    }
  }

  private handleFileInternal(files: File[]) {
    const types = this.acceptTypes ? this.acceptTypes.split(',') : null;
    for (const file of files) {
      if (types) {
        let allowed = false;
        for (const type of types) {
          if (file.name.endsWith(type)) {
            allowed = true;
            break;
          }
        }

        if (!allowed) {
          break;
        }
      }

      if (!this.multiSelect && this.files.length >= 1) {
        this.files = [];
        this.files.push(file);
      } else {
        this.files.push(file);
      }

      this.fileSelected.emit(this.files);
    }
  }

  deleteAttachment(index: number) {
    this.files.splice(index, 1);
    this.fileSelected.emit(this.files);
  }
}
